import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useMemo, createContext, useCallback } from 'react';
import { contentToAst, astToElement } from './ast';
import { BuiltinComponentBuilderList } from './components';
export const ArticleCtx = createContext({});
export const Article = (props) => {
    const { content } = props;
    const ast = useMemo(() => {
        return contentToAst(content, BuiltinComponentBuilderList);
    }, [content]);
    const Inner = useCallback(() => {
        return _jsx(_Fragment, { children: astToElement(ast) });
    }, [ast]);
    return (_jsx(ArticleCtx.Provider, { value: props, children: _jsx(Inner, {}) }));
};
